import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    emptyBankDetailsContainer: {
        '& h6': {
            fontFamily: 'CircularStd',
            fontSize: '26px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.31,
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            textAlign: 'center',
            margin: 0,
            marginBottom: '30px'
        }
    },
    emptybankDetailsOuterSection: {
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
        backgroundColor: '#ffffff',
    },
    emptybankDetailsInnerSection: {
        padding: '60px',
    },
    IconWrapper: {
        width: '173px',
        height: '173px',
        border: 'solid 6px #cccccc',
        borderRadius: '50%',
        margin: '0 auto',
        position: 'relative',
        '& i': {
            position: 'absolute',
            top: '55px',
            left: '96px',
            borderRadius: '50%',
            height: '27px',
            width: '27px',
            backgroundColor: '#ffffff',
            '& svg': {
                margin: '0px',
                height: '26px',
                width: '26px',
            }
        },
        '& svg': {
            width: '61.3px',
            height: '61.2px',
            margin: '55px'
        }
    },
    emptybankDetailsFooterSection: {
        marginTop: '30px',
        textAlign: 'center',
        '& p': {
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.5,
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            margin: '0px',
            '& span': {
                color: '#2d91e9'
            }
        }
    },
    accordionSection: {
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
        marginBottom: '1px',
        wordBreak: 'break-all',
        '& .MuiAccordionSummary-content': {
            '& .MuiTypography-body1': {
                display: 'flex',
                marginTop: '5px'
            }
        },
        '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
            transform: 'rotate(0deg)'
        },
        '& .MuiAccordionSummary-expandIcon': {
            transform: 'rotate(180deg)'
        }
    },
    accordionDetails: {
        padding: '0px 20px 20px 20px',
    },
    bankDetailsContainer: {
        '& h6': {
            fontFamily: 'CircularStd',
            fontSize: '26px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.31,
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            textAlign: 'center',
            margin: 0,
            marginBottom: '30px'
        },
        '& .MuiAccordion-root.Mui-expanded': {
            margin: 0,
            marginBottom: '1px',
        },
        '& .MuiAccordion-root:before': {
            opacity: 0,
        },
    },
    bankDetailsOuterSection: {
        // boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
        backgroundColor: '#ffffff',
        // padding: '20px',
        width: '100%',
    },
    bankDetailsInnerSection: {
        padding: '30px',
        backgroundColor: '#f5f5f5',
        wordBreak: 'break-all',
        '& ul': {
            listStyleType: 'none',
            margin: '0px',
            padding: '0px'
        },
        '& li:nth-child(odd)': {
            fontFamily: 'CircularStd',
            fontSize: '14px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.29,
            letterSpacing: '-0.5px',
            color: '#a4a4a4'
        },
        '& li:nth-child(even)': {
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.13,
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            marginBottom: '15px'
        },
        '& li:last-child': {
            marginBottom: '0px',
        }
    },
    bankDetailsFooterSection: {
        marginTop: '30px',
        textAlign: 'center',
        '& p': {
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.5,
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            margin: '0px',
            '& span': {
                color: '#2d91e9'
            }
        }
    },
    accordionIcon: {
        height: 18,
        marginRight: 10
    },
    loaderWrapper: {
        overflowY: 'hidden'
    },
    footerTextlink: {
        color: "#2D91E9",
        textDecoration: "none",
        fontSize: "16px",
        margin: "-10px 0 0 0px",
        display: "inline-block",
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.4rem',
            lineHeight: 1.45
        },
    },
    ourBankDetailsContainer: {
        padding: '30px',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
    },
    ourBankDetailsHeader: {
        fontFamily: 'CircularStd',
        fontSize: '21px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.31,
        letterSpacing: '-0.5px',
        color: '#4a4a4a',
        textAlign: 'left',
        marginTop: '0px',
        marginBottom: '10px'
    },
    ourBankDetailsDescription: {
        fontFamily: 'CircularStd',
        fontSize: '18px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: '-0.5px',
        color: '#a4a4a4',
        marginTop: '0px',
        marginBottom: '20px'
    },
    fullWidth: {
        width: '100%',
        margin: '0 0 0 0',
        textAlign: 'center',
        '& > div': {
            width: '100% !important',
            display: 'flex !important',
            '& > div': {
                width: '100%',
                display: 'flex',
                '& button': {
                    flex: 1
                }
            }
        }
    },
    countrySelect: {
        width: '100% !important',
        marginBottom: '20px',
        '& .MuiFormControl-root': {
            width: '100% !important'
        },
        '& .MuiAutocomplete-root': {
            width: '100% !important',
            display: 'block !important'
        },
        '& .MuiTextField-root': {
            width: '100% !important'
        }
    },
    legalEntitySelect: {
        width: '100% !important',
        '& .MuiFormControl-root': {
            width: '100% !important'
        },
        '& .MuiAutocomplete-root': {
            width: '100% !important',
            display: 'block !important'
        },
        '& .MuiTextField-root': {
            width: '100% !important'
        }
    },
    blacklistAlert: {
        marginTop: '20px',
        '& .MuiAlert-message': {
            width: '100%'
        }
    },
    currencyListContainer: {
        padding: '30px',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
        marginTop: '20px'
    },
    currencyContainer: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 15,
        '& svg': {
            marginRight: 5
        }
    },
    detailRow: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& h3': {
            fontFamily: 'CircularStd',
            fontSize: '14px',
            fontWeight: 500,
            color: '#4a4a4a',
            marginTop: '0px',
            marginBottom: '20px',
            width: '100%'
        }
    },
    detailsList: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
        width: '100%'
    },
    detailItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px',
        backgroundColor: '#e3f2fd',
        borderRadius: '8px',
        marginBottom: '5px',
        '&:last-child': {
            marginBottom: '0px'
        }
    },
    detailTextContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    detailLabel: {
        fontFamily: 'CircularStd',
        fontSize: '14px',
        fontWeight: 500,
        color: '#a4a4a4',
        marginBottom: '2px'
    },
    detailValue: {
        fontFamily: 'CircularStd',
        fontSize: '14px',
        fontWeight: 500,
        color: '#000000'
    },
    copyIcon: {
        cursor: 'pointer',
        '& svg': {
            width: '18px',
            height: '18px',
            fill: '#2d91e9'
        },
        '&:hover': {
            opacity: 0.7
        }
    },
    expandedCurrencyPanel: {
        margin: '10px 0'
    },
    accordion: {
        boxShadow: 'none',
        borderBottom: '1px solid #e8e8e8',
        '&:last-child': {
            borderBottom: 'none'
        },
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0
        }
    },
    accordionSummary: {
        padding: '0 10px',
        '& .MuiAccordionSummary-content': {
            margin: '10px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    currencyCode: {
        fontWeight: 'bold',
        fontSize: '16px',
        color: '#4a4a4a'
    },
    bankName: {
        fontSize: '14px',
        color: '#a4a4a4'
    },
    expandIcon: {
        color: '#2d91e9',
        transform: 'rotate(180deg)'
    },
    pageHeader: {
        fontFamily: 'CircularStd',
        fontSize: '26px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.31,
        letterSpacing: '-0.5px',
        color: '#4a4a4a',
        textAlign: 'center',
        margin: '0 0 30px 0'
    },
    bankDetailContainer: {
        margin: '10px 10px 0px 10px',
        [theme.breakpoints.down('sm')]: {
            margin: '0',
        }
    },
    APSnackBar: {
        color: '#2D91E9',
        background: '#EAF3FF',
        boxSizing: 'border-box',
        padding: '20px',
        boxShadow: '0 5px 12px 0 rgba(0,0,0,0.08)',
        fontSize: 16,
        right: 'inherit',
        width: '-webkit-fill-available', 
        marginLeft: '10px',
        marginRight: '33px',
        left: 'auto',
        top: '50px',
        zIndex: 1400,
        '@media(min-width: 1200px)': {
            marginRight: '82px'
        },
        '& div': {
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '-0.5px',
            '& svg': {
                width: '20px',
                height: '20px',
                verticalAlign: 'middle',
            }
        }
    },
    snackBarWidth: {
        width: '-moz-available'
    },
    svgTick: {
        marginRight: 6,
    },
    svgIconClose: {
        cursor: 'pointer',
        pointerEvents: 'all',
        marginLeft: 'auto'
    },
    errorSnackBar: {
        color: '#d32f2f',
        background: '#ffebee',
    },
    errorMessageContainer: {
        padding: '20px',
        textAlign: 'center'
    },
    errorMessage: {
        fontFamily: 'CircularStd',
        fontSize: '14px',
        color: '#d32f2f',
        fontWeight: 'normal'
    }
});